import React, { SyntheticEvent } from 'react';
import { Report } from 'core/slices/models';
import { Col, Nav, Row } from 'react-bootstrap';
import { BarChartFill, BookmarkStar, Grid3x2 } from 'react-bootstrap-icons';
import './ReportNavHeaderRow.scss';

interface ReportNavRowProps {
  elem: Report;
  isActive: boolean;
  onNavElemClick: () => void;
  toggleStateBookMark: (e: SyntheticEvent) => void;
}

export const ReportNavHeaderRow: React.FC<ReportNavRowProps> = ({
  elem,
  isActive,
  onNavElemClick,
  toggleStateBookMark,
}) => (
  <div className={`nav-item-container ${isActive ? 'active' : ''}`}>
    <Row className="m-0 w-100">
      <Col sm={10} className="p-0">
        <Nav.Link
          className="nav-item d-flex align-items-center justify-content-center"
          onClick={onNavElemClick}
        >
          <Col sm={1} className="nav-item-icon">
            {elem.tableView ? <Grid3x2 /> : <BarChartFill />}
          </Col>
          <Col className="report-elem-title">{elem.name}</Col>
        </Nav.Link>
      </Col>
      <Col
        sm={2}
        className="nav-item-bookmark d-flex align-items-center justify-content-center chevron-rotate-hover"
        onClick={e => {
          e.stopPropagation(); // Prevent navigation
          toggleStateBookMark(e);
        }}
      >
        <BookmarkStar />
      </Col>
    </Row>
  </div>
);
